import Nullstack from 'nullstack';
export default function IconMarqueeOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-marquee-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M4 6c0 -.556 .227 -1.059 .593 -1.421"
  }), "   ", Nullstack.element("path", {
    d: "M9 4h1.5"
  }), "   ", Nullstack.element("path", {
    d: "M13.5 4h1.5"
  }), "   ", Nullstack.element("path", {
    d: "M18 4a2 2 0 0 1 2 2"
  }), "   ", Nullstack.element("path", {
    d: "M20 9v1.5"
  }), "   ", Nullstack.element("path", {
    d: "M20 13.5v1.5"
  }), "   ", Nullstack.element("path", {
    d: "M19.402 19.426a1.993 1.993 0 0 1 -1.402 .574"
  }), "   ", Nullstack.element("path", {
    d: "M15 20h-1.5"
  }), "   ", Nullstack.element("path", {
    d: "M10.5 20h-1.5"
  }), "   ", Nullstack.element("path", {
    d: "M6 20a2 2 0 0 1 -2 -2"
  }), "   ", Nullstack.element("path", {
    d: "M4 15v-1.5"
  }), "   ", Nullstack.element("path", {
    d: "M4 10.5v-1.5"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}